// extracted by mini-css-extract-plugin
module.exports = {"modal":"styles__modal___2drrv","modal-content":"styles__modal-content___2LGX6","overlay":"styles__overlay___3AWiJ"};